import React from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useStore } from '@/models';
import cx from 'classnames';
import cs from './index.module.scss';
import Menu from './menu';
import Profile from './profile';
import Logo from './logo';
import Setting from './setting';
import Notice from './notice';
import Order from './order';
import Assets from './assets';
import Sign from './sign';

interface Props {
  transparent?: boolean;
}

const Header: React.FC<Props> = ({ transparent }) => {
  const location = useLocation();
  
  // 判断是否在合约或现货页面
  const isTradingPage = /^(\/futures\/contract\/)/.test(location.pathname) || /^(\/spot\/trade\/)/.test(location.pathname);
  return (
    <>
      <header className={cx(cs.header, transparent ? cs.transparent : '', isTradingPage ? cs.whiteBg : cs.grayBg)}>
        <div className={cs.headerGroup}>
          <Logo />
          <Menu />
        </div>

        <div className={cs.headerGroup}>
          {/* <Order /> */}
          {/* <Assets /> */}
          <Sign />
          <Setting />
          <Profile />

          {/* <div className={cx(cs.divider, transparent ? cs.transparent : '')} /> */}

          {/* <div className={cx(cs.divider, transparent ? cs.transparent : '')} /> */}
        </div>
      </header>

      <Notice />
    </>
  );
};

export default observer(Header);
